import { render, staticRenderFns } from "./PartSwitch.vue?vue&type=template&id=df393822&scoped=true&"
import script from "./PartSwitch.vue?vue&type=script&lang=js&"
export * from "./PartSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PartSwitch.vue?vue&type=style&index=0&id=df393822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df393822",
  null
  
)

export default component.exports